var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadicineOrderBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 77,
    viewBox: "0 0 335 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11449_46927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 77
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 77,
    rx: 12,
    fill: "url(#paint0_linear_11449_46927)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 334,
    height: 76,
    rx: 11.5,
    stroke: "url(#paint1_linear_11449_46927)",
    strokeOpacity: 0.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11449_46927)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.084 26.6851C260.087 23.0187 271.979 28.9663 275.646 39.9695C276.877 43.6643 277.024 47.4593 276.26 51.0094L239.883 32.8159C242.265 30.0749 245.389 27.9163 249.084 26.6851ZM235.186 42.2069C234.421 45.757 234.569 49.552 235.8 53.2468C239.466 64.25 251.358 70.1977 262.361 66.5312C266.056 65.3001 269.181 63.1415 271.563 60.4004L235.186 42.2069ZM285.607 36.6502C280.108 20.1454 262.27 11.224 245.765 16.7236C229.26 22.2232 220.339 40.0613 225.838 56.5661C231.338 73.0709 249.176 81.9924 265.681 76.4928C282.186 70.9931 291.107 53.155 285.607 36.6502Z",
    fill: "#ffbb00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.573 0.125791C291.906 -10.8774 280.014 -16.8251 269.011 -13.1586C258.008 -9.49222 252.06 2.39986 255.726 13.4031C256.183 14.7742 256.766 16.062 257.455 17.2602L248.352 22.4948C247.316 20.692 246.445 18.7628 245.765 16.7224C240.265 0.217577 249.187 -17.6205 265.692 -23.1202C282.196 -28.6198 300.035 -19.6983 305.534 -3.19353C311.034 13.3113 302.112 31.1494 285.607 36.649C283.567 37.3289 281.501 37.7893 279.437 38.0411L278.165 27.6184C279.537 27.451 280.917 27.1444 282.288 26.6875C293.291 23.0211 299.239 11.129 295.573 0.125791Z",
    fill: "#ffbb00"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -6,
    r: 114,
    fill: "#A18AF5",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -6,
    r: 101.9,
    stroke: "url(#paint2_linear_11449_46927)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9 -6C73.9 44.755 32.755 85.9 -18 85.9C-68.755 85.9 -109.9 44.755 -109.9 -6C-109.9 -56.755 -68.755 -97.9 -18 -97.9C32.755 -97.9 73.9 -56.755 73.9 -6Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint3_linear_11449_46927)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9 -6C63.9 39.2321 27.2321 75.9 -18 75.9C-63.2321 75.9 -99.9 39.2321 -99.9 -6C-99.9 -51.2321 -63.2321 -87.9 -18 -87.9C27.2321 -87.9 63.9 -51.2321 63.9 -6Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint4_linear_11449_46927)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9 -6C52.9 33.157 21.157 64.9 -18 64.9C-57.157 64.9 -88.9 33.157 -88.9 -6C-88.9 -45.157 -57.157 -76.9 -18 -76.9C21.157 -76.9 52.9 -45.157 52.9 -6Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint5_linear_11449_46927)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9 -6C42.9 27.6341 15.6341 54.9 -18 54.9C-51.6341 54.9 -78.9 27.6341 -78.9 -6C-78.9 -39.6341 -51.6341 -66.9 -18 -66.9C15.6341 -66.9 42.9 -39.6341 42.9 -6Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint6_linear_11449_46927)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9 -6C32.9 22.1113 10.1113 44.9 -18 44.9C-46.1113 44.9 -68.9 22.1113 -68.9 -6C-68.9 -34.1113 -46.1113 -56.9 -18 -56.9C10.1113 -56.9 32.9 -34.1113 32.9 -6Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint7_linear_11449_46927)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11449_46927",
    x1: 15,
    y1: 17.5761,
    x2: 358.169,
    y2: 100.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEB5FF",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11449_46927",
    x1: -4.7111e-7,
    y1: 1.925,
    x2: 170.791,
    y2: 211.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7EDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11449_46927",
    x1: 71.5,
    y1: 54,
    x2: -70,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11449_46927",
    x1: 62.7255,
    y1: 48.1176,
    x2: -64.902,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11449_46927",
    x1: 53.951,
    y1: 42.2353,
    x2: -59.8039,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11449_46927",
    x1: 44.299,
    y1: 35.7647,
    x2: -54.1961,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11449_46927",
    x1: 35.5245,
    y1: 29.8823,
    x2: -49.098,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11449_46927",
    x1: 26.75,
    y1: 24,
    x2: -44,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadicineOrderBackground);
export default __webpack_public_path__ + "static/media/MadicineOrderBackground.c3a9fc232cc5e0e24fb2ea6425d7a447.svg";
export { ForwardRef as ReactComponent };